import { Subject } from 'rxjs';

import { Injectable, OnDestroy } from '@angular/core';

@Injectable()
export class LifecycleHooks implements OnDestroy {
  private destroyed = false;

  private destroy = new Subject<void>();

  readonly destroy$ = this.destroy.asObservable();

  get isDestroyed(): boolean {
    return this.destroyed;
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.destroy.next();
    this.destroy.complete();
  }
}
